import { _ALIAS_SUFFIX, _NEW_LINE, _THREE_DOTS, _dict, _lang } from "../components/constants";
import Tesseract from 'tesseract.js';

// REF-A
function text2Sencences(text: string, ignoreNewLines:boolean): string[] {
  // NOTE: THIS IS CALLED ONLY IN STORY MODE! OTHERWISE DO NOT ADD _NEW_LINE!
  
  let sentences: string[] = [];
  // Split the text by new line, dot or semicolon
  sentences = text.split(/[\n.;]/);

  if(ignoreNewLines === false){
    // Add _NEW_LINE element after each sentences element
    sentences = sentences.flatMap(sentence => [sentence, _NEW_LINE]);
  }
  
  
  // Remove any empty sentences and return the result
  return sentences.filter(sentence => sentence.trim() !== '');
}

export function sentence2chunks(sentence: string, minChunkChars: number): string[] {
    const words = sentence.split(' ');
    const chunks: string[] = [];
    let currentChunk = '';
  
    for (const word of words) {
      // If adding the next word to the current chunk would make its length exceed minChars,
      // and the current chunk already has at least minChars,
      // add the current chunk to the chunks array and start a new chunk with the current word
      if ((currentChunk + ' ' + word).replace(/[^a-zA-Z]/g, '').length > minChunkChars && currentChunk.replace(/[^a-zA-Z]/g, '').length >= minChunkChars) {
        chunks.push(currentChunk.trim());
        currentChunk = word;
      } else {
        // Otherwise, add the word to the current chunk
        currentChunk += ' ' + word;
      }
    }
  
    // Add the last chunk to the chunks array
    if (currentChunk.trim() !== '') {
      chunks.push(currentChunk.trim());
    }
  
    return chunks;
  }

  /*export function sentence2chunks(sentence: string, minChunkChars: number): string[] {
    // Remove new lines and trim
    sentence = sentence.replace(/\n/g, " ").trim();
    const chunks: string[] = [];
    let currentChunkArray: string[] = [];

    for (const word of sentence.split(" ")) {
        const trimmedWord = word.trim();
        if (trimmedWord) {
            // Get current potential chunk:
            currentChunkArray.push(trimmedWord);
            const currentChunk = currentChunkArray.join(" ");
            const nrChars = currentChunk.replace(/ /g, '').length; // Include all characters except spaces
            const nrWords = currentChunkArray.length;
            const lenOfLastWord = currentChunkArray[currentChunkArray.length - 1].length;
            const meanWordLength = nrChars / nrWords;

            // Conditions to split chunks
            if ((lenOfLastWord > 3 && meanWordLength > 4 && nrChars * nrWords > 5) &&
                nrChars > minChunkChars) {
                chunks.push(currentChunk.trim());
                currentChunkArray = [];
            }
        }
    }

    // Add the last chunk to the chunks array, if it meets the conditions
    if (currentChunkArray.length > 0) {
        const lastChunk = currentChunkArray.join(" ").trim();
        if (lastChunk !== '') {
            chunks.push(lastChunk);
        }
    }

    return chunks;
}*/







export function storyToDict(
    startingLevel: string,
    story:string,
    minChunkChars:number,
    showOneSentenceAtATime:boolean,
    ignoreNewLines:boolean){
    
    const dict: { [key: string]: string[] } = { [startingLevel]: [] };
    let labelsQueue: string[] = [];
    const sentences = text2Sencences(story, ignoreNewLines);
    
    if(showOneSentenceAtATime === true){
      // Iterate over sentences and track the current index
      let sentenceIndex = 0;
      const lastSentenceIndex = sentences.length - 1;
      let currentLevel = startingLevel;
      for (const sentence of sentences) {
          // Split the sentence into chunks
          const chunks = sentence2chunks(sentence, minChunkChars);
          
          // Add a chunk to dict at key currentLevel
          if (!dict[currentLevel]) {
              dict[currentLevel] = [];
          }
          dict[currentLevel] = [...dict[currentLevel], ...chunks];
          // Add ... at the end of the sentence, if it's not the last sentence
          if(sentenceIndex !== lastSentenceIndex && dict[currentLevel].length > 0){
              dict[currentLevel] = [...dict[currentLevel], _THREE_DOTS];
          }
          currentLevel = currentLevel + "."+ _THREE_DOTS;
          sentenceIndex = sentenceIndex + 1;
          
          // Update of labelsQueue, according to words priority
          // (i.e. order of appearance) for the user
          labelsQueue = [...labelsQueue, ...chunks];
      }
    }else{
      // Instead of splitting sentences among different levels, they are all added to the same startingLevel
      const chunks = sentences.flatMap(sentence => sentence2chunks(sentence, minChunkChars));
      dict[startingLevel] = [...dict[startingLevel], ...chunks];
      labelsQueue = [...labelsQueue, ...chunks];
      
    }

    return { dict, labelsQueue };
}

export const longestWordLength = (sentence: string) => Math.max(...sentence.split(' ').map(word => word.length));
export const longestWordInList = (sentences: string[]) => Math.max(...sentences.map(sentence => longestWordLength(sentence)));

export function cleanAIAnswer(AIAnswer: string, lang:string): string {
  // Remove wrapping double quotes
  if (AIAnswer.startsWith('"') && AIAnswer.endsWith('"')) {
    AIAnswer = AIAnswer.substring(1, AIAnswer.length - 1);
  }

  // Find the last period in the AIAnswer
  const lastPeriodIndex = AIAnswer.lastIndexOf('.');

  // If there's an interrupted sentence at the end, remove it
  if (lastPeriodIndex !== -1 && lastPeriodIndex !== AIAnswer.length - 1) {
    AIAnswer = AIAnswer.substring(0, lastPeriodIndex + 1);
  }

  // After each sentence there should be a space, if not already present, add it
  AIAnswer = AIAnswer.replace(/\.([^ ])/g, '. $1');

  // If words "status", "code" and "429" are found in AIAnswer, use tooManyRequests from _dict
  if (AIAnswer.toLowerCase().includes('status') && AIAnswer.toLowerCase().includes('code') && AIAnswer.toLowerCase().includes('429')) {
    AIAnswer = _dict.tooManyRequests[lang];
  }


  return AIAnswer.trim();
}


export async function imageToText(image:string, lang:string){
  try {
    const langMap: {[id:string]: string} = {
      en: 'eng',
      it: 'ita',
      de: 'deu',
    };
    const result = await Tesseract.recognize(
      image,
      langMap[lang] || langMap[_lang],
    { logger: m => {/*console.log(m)*/} }
    );
    return result.data.text;
  } catch (error) {
      return null;
    }
}


export const cleanText = (text: string, isList:boolean) => {
  //console.log(text);
  if(isList){
  // Remove empty lines or lines containing only spaces
  text = text.replace(/^\s*[\r\n]/gm, "");
  }else{
  // Remove new lines
    text = text.replace(/\n/g, " ");
  }
  //console.log(text);

  // Remove characters which are not alphanumerical and any of special chars you can expect to see in a human written text
  text = text.replace(/[^a-zA-Z0-9.,!? \n]/g, "");
  //console.log(text);

  return text;
};



function levenshteinDistance(a: string, b: string): number {
  if (a.length === 0) return b.length; 
  if (b.length === 0) return a.length;

  const matrix = [];

  // Increment along the first column of each row
  for (let i = 0; i <= b.length; i++) {
      matrix[i] = [i];
  }

  // Increment each column in the first row
  for (let j = 0; j <= a.length; j++) {
      matrix[0][j] = j;
  }

  // Fill in the rest of the matrix
  for (let i = 1; i <= b.length; i++) {
      for (let j = 1; j <= a.length; j++) {
          if (b.charAt(i - 1) === a.charAt(j - 1)) {
              matrix[i][j] = matrix[i - 1][j - 1];
          } else {
              matrix[i][j] = Math.min(matrix[i - 1][j - 1] + 1, Math.min(matrix[i][j - 1] + 1, matrix[i - 1][j] + 1));
          }
      }
  }

  return matrix[b.length][a.length];
}

function splitIntoWords(str: string): string[] {
  // Splitting the string by spaces and punctuation, and filtering out short words.
  return str.toLowerCase().split(/[\s,.!?;:'"-]+/).filter(word => word.length > 3);
}

function hasCommonWords(a: string, b: string): boolean {
  const wordsA = new Set(splitIntoWords(a));
  const wordsB = new Set(splitIntoWords(b));

  for (let word of wordsA) {
      if (wordsB.has(word)) {
          return true;
      }
  }

  return false;
}

function preprocessString(str: string): string {
  return str.replaceAll(_ALIAS_SUFFIX, '').toLowerCase().trim();
}

function isSimilar(input: string, target: string, threshold: number = 2): boolean {
  const preprocessedInput = preprocessString(input);
  const preprocessedTarget = preprocessString(target);
  if(preprocessedInput.length < 3){
    return preprocessedInput === preprocessedTarget || hasCommonWords(preprocessedInput, preprocessedTarget);
  }

  return levenshteinDistance(preprocessedInput, preprocessedTarget) <= threshold 
         || hasCommonWords(preprocessedInput, preprocessedTarget);
}

export function findSimilarStrings(input: string, strings: string[], threshold: number = 2): string[] {
  return strings.filter(s => isSimilar(input, s, threshold));
}

export function countSimilarStringsWithDuplicates(input: string, strings: string[], threshold: number = 2): number {
  return findSimilarStrings(input, strings, threshold).length;
}

